import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Icon } from '../ui';
import styles from './AppLayout.module.css';

interface TabItem {
  path: string;
  icon: string;
  label: string;
}

const tabs: TabItem[] = [
  { path: '/', icon: 'food', label: 'Account' },
  { path: '/event', icon: 'calendar-month-outline', label: 'Event Info' },
  { path: '/profile', icon: 'account-outline', label: 'Profile' },
];

export function AppLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => {
    if (path === '/') {
      return location.pathname === '/' ||
        location.pathname === '/buy-coins' ||
        location.pathname === '/pay-vendor' ||
        location.pathname === '/history' ||
        location.pathname === '/scan-help';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className={styles.container}>
      <main className={styles.content}>
        <Outlet />
      </main>
      <nav className={styles.tabBar}>
        {tabs.map((tab) => (
          <button
            key={tab.path}
            className={`${styles.tab} ${isActive(tab.path) ? styles.tabActive : ''}`}
            onClick={() => navigate(tab.path)}
          >
            <Icon
              name={tab.icon}
              backgroundColor={isActive(tab.path) ? 'var(--toc-pink)' : 'var(--medium)'}
              iconColor="white"
              size={28}
            />
            <span className={styles.tabLabel}>{tab.label}</span>
          </button>
        ))}
      </nav>
    </div>
  );
}

export default AppLayout;
